import { defineMessages } from "react-intl";
const messages = defineMessages({
    communitiesViewLabel: {
        id: "app.users.createUser.communities.label.text",
        defaultMessage: "Select communities this user can view",
    },
    communitiesSelectPlaceholder: {
        id: "app.users.createUser.communities.placeholder.text",
        defaultMessage: "+ Add Community",
    },
});
export default messages;
